"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
function default_1({ fondeeDayArr, targetDate, is_withdraw, }) {
    const compareDates = (date1, date2) => {
        const dateA = new Date(date1);
        const dateB = new Date(date2);
        if (dateA < dateB)
            return -1;
        if (dateA > dateB)
            return 1;
        return 0;
    };
    const formattedTargetDate = (0, moment_1.default)(targetDate).format('YYYY-MM-DD');
    const getTargetDateIndex = () => {
        let left = 0;
        let right = fondeeDayArr.length - 1;
        let nextLargerIndex = -1;
        while (left <= right) {
            const mid = Math.floor((left + right) / 2);
            const midDate = fondeeDayArr[mid];
            const comparison = compareDates(midDate, formattedTargetDate);
            if (comparison === 0) {
                return mid;
            }
            else if (comparison < 0) {
                left = mid + 1;
            }
            else {
                nextLargerIndex = mid;
                right = mid - 1;
            }
        }
        return nextLargerIndex;
    };
    const targetDateIndex = getTargetDateIndex();
    if (targetDateIndex === -1) {
        return;
    }
    else if (is_withdraw) {
        return fondeeDayArr[targetDateIndex + 1];
    }
    else
        return fondeeDayArr[targetDateIndex + 3];
}
exports.default = default_1;
